import React, { useEffect, useState } from 'react';
import { getAuth, onAuthStateChanged } from 'firebase/auth';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import LoginPage from './pages/LoginPage';
import RemotePage from './pages/RemotePage';
import AppsPage from './pages/AppsPage';
import GroupsPage from './pages/GroupsPage';
import OTAUpdatePage from './pages/OTAUpdatePage';
import UpdatePage from './pages/UpdatePage';
import AOSPUpdaterPage from './pages/AOSPUpdaterPage';
import AnalyticsRulesPage from './pages/AnalyticsRulesPage';
import HealthPage from './pages/HealthPage';
import DevicesPage from './pages/DevicesPage';
import DeviceDetailPage from './pages/DeviceDetailPage';
import DashboardPage from './pages/DashboardPage';
import AddDevice from './pages/AddDevice';
import ProvisioningPage from './pages/ProvisioningPage';
import MainLayout from './components/MainLayout';

function App() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const getAllowedEmails = () => {
    const raw = process.env.REACT_APP_ALLOWED_USERS || '';
    return raw.split(',').map(email => email.trim().toLowerCase());
  };

  const allowedEmails = getAllowedEmails();

  useEffect(() => {
    const auth = getAuth();

    const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
      if (currentUser && allowedEmails.includes(currentUser.email?.toLowerCase())) {
        setUser(currentUser);
      } else {
        setUser(null); // auto-reject unauthorized user
      }
      setLoading(false);
    });

    return () => unsubscribe();
  }, []);

  if (loading) return <p className="text-center mt-10 text-white bg-gray-900 min-h-screen">Loading...</p>;

  return (
    <Router>
      {!user && (
        <Routes>
          <Route
              path="/login"
              element={<LoginPage onLogin={() => {
                const currentUser = getAuth().currentUser;
                if (currentUser && allowedEmails.includes(currentUser.email?.toLowerCase())) {
                  setUser(currentUser);
                } else {
                  alert('Unauthorized user');
                  getAuth().signOut();
                }
              }} />}
          />
          <Route path="*" element={<Navigate to="/login" />} />
        </Routes>
      )}

      {user && (
        <MainLayout>
          <Routes>
            <Route path="/dashboard" element={<DashboardPage />} />
            <Route path="/remote" element={<RemotePage />} />
            <Route path="/apps" element={<AppsPage />} />
            <Route path="/groups" element={<GroupsPage />} />
            <Route path="/groups/:groupId" element={<GroupsPage />} />
            <Route path="/devices" element={<DevicesPage />} />
            <Route path="/health" element={<HealthPage />} />
            <Route path="/devices/:mac" element={<DeviceDetailPage />} />
            <Route path="/update" element={<UpdatePage />} />
            <Route path="/ota" element={<OTAUpdatePage />} />
            <Route path="/aosp-updater" element={<AOSPUpdaterPage />} />
            <Route path="/analytics-rules" element={<AnalyticsRulesPage />} />
            <Route path="/add-device" element={<AddDevice />} />
            <Route path="/provisioning" element={<ProvisioningPage />} />
            <Route path="*" element={<Navigate to="/dashboard" />} />
          </Routes>
        </MainLayout>
      )}
    </Router>
  );
}

export default App;